export default __webpack_public_path__ + "static/media/WorkSans-Light.c3bb8eba.ttf";